import { Hub } from '@sentry/core/types/hub';
import axios from 'axios';
import { memoize } from 'lodash/fp';

import { captureException } from '@skippay/core/global/errorTracking';
import { delay } from '@skippay/core/utils/promiseUtils';

const smartformAxiosInstance = axios.create();

type SmartformValidatorResult = boolean | Error | Hub['captureException'];
const smartformEmailValidator = memoize(
	(email: string) =>
		new Promise<SmartformValidatorResult>((resolve, reject) => {
			return smartformAxiosInstance
				.post(`${process.env.SMARTFORM_API_URL}/smartform-ws/validateEmail/v1`, {
					emailAddress: email,
				})
				.then((response) => {
					if (response.data.result === 'NOT_EXISTS') {
						reject(new Error('Email address does not exist'));
					}
					resolve(true);
				})
				.catch((error) =>
					captureException(new Error('Validating email address via Smartform has failed'), {
						extra: { originalError: error },
					})
				);
		})
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EmailValidator = Promise<SmartformValidatorResult | void>;
export const validateSmartformEmail = (email: string): EmailValidator =>
	Promise.race<EmailValidator>([smartformEmailValidator(email), delay(5000)]);
